/**
 * Polyfill for Promise.withResolvers (ES2024).
 * Required by pdfjs-dist v4+/v5 on browsers older than Chrome 119 / Safari 17.4.
 */

declare global {
  interface PromiseConstructor {
    withResolvers<T = unknown>(): {
      promise: Promise<T>;
      resolve: (value: T | PromiseLike<T>) => void;
      reject: (reason?: unknown) => void;
    };
  }
}

export function ensurePromiseWithResolvers(): void {
  if (typeof Promise.withResolvers === 'function') return;

  Promise.withResolvers = function withResolvers<T = unknown>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

ensurePromiseWithResolvers();
